/** Reports lug'ati (uz) */
export default {
  title: "Hisobotlar",
  subtitle: "{{scope}} · {{period}} ({{prev}} bilan)",
  tabs: { recruiters: "Recruiterlar", sources: "Manbalar", carriers: "Carrierlar", branches: "Filiallar", funnel: "Voronka", retention: "Saqlanish", trends: "Trendlar", finance: "Moliya" },
  scope: { all: "Barcha filiallar", branch: "Filial" },
  filters: { branch: "Filial", recruiter: "Recruiter", allBranches: "Barcha filiallar", myBranches: "Barcha filiallarim", locked: "{{branch}} · qulflangan", allRecruiters: "Barcha recruiterlar" },
  recruiters: {
    funnel: "Voronka · {{month}}",
    retentionTitle: "Ishga olinganlarning saqlanishi",
    retentionSub: "tasdiqlangan ishga olishlar bo'yicha; N kundan keyin hali ishlayotganlar ulushi",
    title: "Recruiterlar · {{count}}",
    sub: "Raqamlar status tarixidan olinadi. Ishga olingan deb faqat menejer tasdiqlaganlar hisoblanadi.",
    cols: { recruiter: "Recruiter", new: "Yangi", contacted: "Bog'lanilgan", qualified: "Mos", submitted: "Yuborilgan", hired: "Ishga olingan", conv: "Konv.", retention: "Saqlanish 30/60/90", avgTime: "O'rt. ishga olish vaqti", topLoss: "Asosiy yo'qotish sababi", calls: "Qo'ng'iroqlar" },
    empty: "Bu doirada recruiterlar yo'q.",
    pending: "+{{count}} kutmoqda",
    total: "Jami",
    showing_one: "{{count}} ta recruiter ko'rsatilmoqda",
    showing_other: "{{count}} ta recruiter ko'rsatilmoqda",
  },
  sources: {
    title: "Manba bo'yicha", sub: "qaysi manba haqiqatan ishga olinadigan driverlarni keltiradi",
    cols: { source: "Manba", new: "Yangi", hired: "Ishga olingan", conversion: "Konversiya" },
    empty: "Bu davrda driverlar yo'q.", chart: "Yangi va ishga olingan", new: "Yangi", hired: "Ishga olingan",
  },
  carriers: {
    title: "Carrier bo'yicha", sub: "bu davrdagi yuborishlar va ularning natijasi",
    cols: { carrier: "Carrier", submitted: "Yuborilgan", hired: "Ishga olingan", rejected: "Rad etilgan", rate: "Rad etish ulushi", reasons: "Asosiy sabablar" },
    empty: "Bu davrda yuborishlar yo'q.",
  },
  branches: { title: "Filiallar yonma-yon", sub: "Byudjet ustunlari Byudjet modulidan olinadi" },
  funnel: { title: "To'liq voronka · {{period}}", sub: "davrda har bosqichga yetgan driverlar; % = oldingi bosqichdan", lossTitle: "Driverlar qayerda yo'qotiladi", lossSub: "Rad etilgan / Qiziqmagan / Ketgan sabablari" },
  retention: {
    card: "{{days}} kunlik saqlanish",
    stillWorking: "{{eligible}} ishga olinganidan {{retained}} hali ishlamoqda",
    none: "{{days}} kundan eski ishga olishlar hali yo'q",
    title: "Ishga olinganlarning saqlanishi",
    sub: "boshlash sanasi N kundan eski bo'lgan tasdiqlangan ishga olishlar; ketganlar yo'qotilgan hisoblanadi",
  },
  periodPicker: { kind: "Davr turi", month: "Oy", quarter: "Chorak", year: "Yil", range: "Ixtiyoriy sana", from: "Boshlanishi", to: "Tugashi", value: "Davr" },
  export: { button: "Excel", title: "Shu tabni Excel faylga yuklab olish (o'sha filtrlar va davr)" },
  delta: { none: "solishtirib bo'lmaydi", same: "avvalgidek", new: "avval yo'q edi", pp: "{{value}} p.p.", vs: "{{period}} bilan solishtirilgan" },
  summary: { new: "Yangi driverlar", submitted: "Carrierlarga yuborilgan", hired: "Ishga olingan", conversion: "Konversiya", timeToHire: "Ishga olishgacha kun", days: "{{n}} kun", lost: "Yo'qotilgan" },
  trends: {
    hiresTitle: "Yangi driverlar va ishga olishlar · 12 oy",
    hiresSub: "Ishga olish -- tasdiqlanganlari; konversiya = ishga olish / oyning yangi driverlari",
    series: { new: "Yangi driverlar", hired: "Ishga olingan", conversion: "Konversiya" },
    sourcesTitle: "Manbalar bo'yicha yangi driverlar · 12 oy",
    sourcesSub: "Driverlar qayerdan kelyapti, oyma-oy",
    otherSources: "Boshqa manbalar",
    empty: "Bu oylarda yangi driver yo'q.",
    tableTitle: "Oyma-oy",
    col: { month: "Oy", contacted: "Bog'lanilgan", submitted: "Yuborilgan", lost: "Yo'qotilgan" },
  },
  finance: {
    branchOnly: "Pul filial bo'yicha hisoblanadi: recruiter filtri bu tabni o'zgartirmaydi.",
    noFeeAmount_one: "{{count}} ta ishga olishda carrier to'lovi summasi yo'q, shuning uchun daromad haqiqatdagidan kam ko'rinadi.",
    noFeeAmount_other: "{{count}} ta ishga olishda carrier to'lovi summasi yo'q, shuning uchun daromad haqiqatdagidan kam ko'rinadi.",
    expected: "Kutilgan daromad",
    expectedHint: "Shu davrda tasdiqlangan ishga olishlar uchun carrier to'lovlari",
    received: "Tushgan pul",
    receivedHint: "Shu davrda hisoblarga tushgan carrier to'lovlari (Budjet → Pul)",
    cost: "Xarajat",
    costHint: "Tasdiqlangan xarajat, maosh va bonuslar (Budjet), davrning to'liq oylari",
    profit: "Foyda",
    profitHint: "Kutilgan daromad minus xarajat",
    costPerHire: "Bir ishga olish narxi",
    revenuePerHire: "Bir ishga olish daromadi",
    hiresN_one: "{{count}} ta ishga olish",
    hiresN_other: "{{count}} ta ishga olish",
    chartTitle: "Daromad va xarajat · 12 oy",
    chartSub: "USD da; UZS summalar o'z kunining kursi bilan",
    series: { expected: "Kutilgan daromad", cost: "Xarajat", profit: "Foyda" },
    carriersTitle: "Carrierlar",
    carriersSub: "Shu davr ishga olishlari: kutilgan, tushgan va hali qarz",
    branchesTitle: "Filiallar",
    branchesSub: "Har filialda ishga olish, xarajat va foyda",
    empty: "Bu davrda ishga olish yo'q.",
    col: { carrier: "Carrier", hires: "Ishga olish", expected: "Kutilgan", received: "Tushgan", outstanding: "Qarz", status: "To'lovlar", branch: "Filial", cost: "Xarajat", profit: "Foyda", costPerHire: "Bir ishga olish narxi" },
    paidN: "{{count}} ta to'langan",
    pendingN: "{{count}} ta kutilmoqda",
    notPaidN: "{{count}} ta to'lanmagan",
  },
};
